export const warningInformText = 'You are changing the organisation type.';
export const warningInformTextBody = `We inform you that after saving the form the users of
this organisation will lose access to the information, roles and rights which are specific
for the revoked organisation type.`;
